// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#skeleton{display:flex;margin:auto 0 auto 8px;justify-content:flex-start}@media screen and (max-width:1024px)and (min-width:0px){#skeleton{flex-wrap:wrap}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
